export default __webpack_public_path__ + "static/media/poston.7fe3442f.png";